/*
 * File: ProcedureCodeSearchResults.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the list of procedure codes returned from the search endpoint
 */
import React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import PropTypes from "prop-types";
import { PropTypes as mobxProbTypes } from "mobx-react";
import { Instance } from "mobx-state-tree";
import { ProcedureCodeFeeModel } from "../../store/UISearchStore";
import ChargeModel from "../../store/ChargeModel";

function formatSecondaryText(description: string, fee: string) {
  return (
    <span>
      {description}
      <br />
      {fee}
    </span>
  );
}

type Props = {
  searchResults: Instance<typeof ProcedureCodeFeeModel>[];
  parentCallBack: () => void;
  chargeModel: Instance<typeof ChargeModel>;
};

const ProcedureCodeSearchResults = ({
  searchResults,
  parentCallBack,
  chargeModel
}: Props) => {
  const listResults = searchResults.map((i, index) => {
    const code = i.code;
    const description = i.description;
    const fee = i.fee.toFixed(2);
    const units = i.units;
    const calculationMethod = i.calculationMethod;

    function addSearchResultToChargeModel() {
      chargeModel.update("procedure", code);
      chargeModel.update("description", description);
      chargeModel.update("unitFee", Number(fee));
      chargeModel.update("units", units);
      chargeModel.update("calculationMethod", calculationMethod);
      parentCallBack();
    }

    return (
      <ListItem
        key={index}
        onClick={() => {
          addSearchResultToChargeModel();
        }}
      >
        <ListItemText
          primary={code}
          secondary={formatSecondaryText(description, fee)}
        />
      </ListItem>
    );
  });

  return (
    <div>
      <List className="navList">{listResults}</List>
    </div>
  );
};

ProcedureCodeSearchResults.propTypes = {
  parentCallBack: PropTypes.func.isRequired,
  searchResults: mobxProbTypes.observableArray.isRequired,
  chargeModel: PropTypes.object.isRequired
};

export default ProcedureCodeSearchResults;
